import SampleTrendsView from '@/components/SampleTrendsView';

export default function InfluentTrendsPage() {
  return (
    <SampleTrendsView
      sampleType="influent"
      title="Influent Sample Trends"
      subtitle="Select influent samples to view trend analysis and generate regulatory reports"
    />
  );
}
